import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Divider,
  Flex,
  Text,
} from "@chakra-ui/react";
import React from "react";

interface IAlertProps {
  onClose: () => void;
  isOpen: boolean;
  title: string | React.ReactNode;
  message: string | React.ReactNode;
  onOk: () => void;
  isLoading: boolean;
  confirmText: string;
}

export default function Alert({
  onClose,
  isOpen,
  title,
  message,
  onOk,
  isLoading,
  confirmText,
}: IAlertProps) {
  const cancelRef = React.useRef<any>();

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
    >
      <AlertDialogOverlay />
      <AlertDialogContent maxW="50vw">
        <Flex direction="column">
          <AlertDialogHeader bg="white" color="black" borderTopRadius="4px">
            {title}
          </AlertDialogHeader>
          <AlertDialogCloseButton color="richText.500" fontSize="14" />
          <Divider color="border.500" height="2px"></Divider>
          <AlertDialogBody marginY={4}>
            <Text size="sm" color="settingText.500">
              {" "}
              {message}
            </Text>
          </AlertDialogBody>
          <Divider></Divider>
          <AlertDialogFooter>
            <Button bg="red.300" onClick={onOk} isLoading={isLoading}>
              {confirmText}
            </Button>
            <Button
              ml={3}
              variant="outline"
              border="2px"
              borderColor="border.500"
              ref={cancelRef}
              onClick={onClose}
            >
              Cancel
            </Button>
          </AlertDialogFooter>
        </Flex>
      </AlertDialogContent>
    </AlertDialog>
  );
}
